import useLightMode from './useLightMode';

export default function useTheme(){
    const { theme } = useLightMode();
    return theme;
}